const endpoints = {
  login: "/auth/login",
  loginVerifyTwoFactor: "/auth/login/verify-2fa",
  validateToken: "/auth/validate-token",

  config: "/config",

  customPermissions: '/users/custom-permissions',

  dashboard: "/dashboard",
  dashboardBalancePerCoin: "/dashboard/balance-per-coin",
  dashboardVolumeOfOperations: "/dashboard/volume-of-operations",
  dashboardVolumeOfOperationsPerCoin:
    "/dashboard/volume-of-operations-per-coin",
  user: "/user",
  users: "/users",
  usersProfile: "/users/profile",
  usersDetails: "/users/details",
  userBanks: "/users/banks",
  allUsers: "/users/all",
  usersExport: "/users/export",
  usersRegimen: "/users/regimen",
  usersCognitoProfile: "/users/cognito-profile",
  enableRiskUser: "/users/enable-risk-user",
  whiteList: "/users/white-list",

  userIdentity: "/users/identity",
  usersConfiguration: "/users/configuration",
  usersConfigurationSwapFee: "/users/configuration/swap-fee",
  userIdentityReset: "/users/identity/reset",
  changeAccountEnablement: "/users/enablement",
  changeTypeUser: "/users/type-user",
  changeUserCoinPermission: "/users/coin-permission",
  sendSMS: "/users/sms",
  sendPushApp: "/users/push-app",
  allOperations: "/operations/all",
  operations: "/operations",
  operationUuid: "/operations/{uuid}",
  operationsGift: "/operations/gift",
  operationsGiftDistribution: "/operations/gift-distribution",
  operationsReceiveBlockchain: "/operations/receive-blockchain",
  operationDepositApply: "/operations/deposit/{uuid}/apply",
  operationWithdrawApply: "/operations/withdraw/{uuid}/apply",
  operationWithdrawTransferApply: "/operations/withdraw-transfer/{uuid}/apply",
  operationWithdrawProviderApply: "/operations/withdraw/{uuid}/apply-provider",
  operationsSendBlockchainApply: "/operations/send-blockchain/{uuid}/apply",
  operationsReceiveBlockchainApply: "/operations/receive-blockchain/{uuid}/apply",
  operationsExportROS: "/operations/export/ROS",
  operationsExportCommissions: "/operations/export/commissions",
  operationsExportOperations: "/operations/export",
  operationWithdraw: "/operations/create-withdraw",

  allCoins: "/coins/all",
  allCoinsBlockchain: "/coins/blockchain",

  authToken: "/auth/token",
  authPresignedRegimen: "/auth/presigned-regimen/${userId}",
  authPresignedOperationWithdraw:
    "/auth/presigned-operations-withdraw/${operationId}",

  notes: "/notes/{userId}",
  downloadRegimenFilesFromNote: "/notes/{noteId}/download-regimen-files",

  giftCards: "/giftCards",

  crmWhatsapp: "/crm/whatsapp",
  crmWhatsappDetail: "/crm/whatsapp/{id}",
  crmWhatsappUploadImage: "/crm/whatsapp/upload-image",

  crmSms: "/crm/sms",
  crmSmsDetail: "/crm/sms/{id}",
  crmSmsBalance: "/crm/sms/balance",
};

export default endpoints;
